export default __webpack_public_path__ + "static/media/iconLine.f49af389.svg";